/** Traductions modal reçu commerçant (FR / AR) */
export const merchantReceiptModalFr = {
  title: 'Reçu du Commerçant',
  printing: 'Impression...',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  printError: 'Erreur lors de l\'impression du reçu',
  keyboardHint: 'Entrée = confirmer · Esc = fermer'
};

export const merchantReceiptModalAr = {
  title: 'إيصال التاجر',
  printing: 'جاري الطباعة...',
  confirm: 'تأكيد',
  cancel: 'إلغاء',
  printError: 'خطأ في طباعة الإيصال',
  keyboardHint: 'Enter = تأكيد · Esc = إغلاق'
};
